// extracted by mini-css-extract-plugin
export default {"property":"BranchInfo_property__ZNSn4","icon":"BranchInfo_icon__UCbJN","content":"BranchInfo_content__kTii2"};